import DialogComponent from '../../widgets/dialog/DialogComponent';

export default class RemoveGroupDialog extends DialogComponent {

  onRemove = () => {
    this.resolve(true);
    this.close();
  }

  onCancel = () => this.close();

  render() {
    return (
      <div className="confirm-dialog">
        <div className="d-flex align-items-start">
          <span className="confirm-icon-wrapper">
            <i className="fal fa-exclamation-circle fa-lg" style={{ color: '#FF9F0A' }}></i>
          </span>
          <div>
            <span className="confirm-title">آیا میخواید این گروه را حذف کنید؟</span>
            <div className="confirm-description">
              <p>توجه داشته باشید که در صورت حذف شدن گروه، سنسورهای داخل آن به بخش دسته بندی نشده انتقال داده میشوند.</p>
            </div>
          </div>
        </div>
        <div className="row mb-3"><hr style={{ width: '100%' }} /></div>
        <div className="confirm-button-wrapper ltr text-left">
          <button className="btn btn-outline-danger" onClick={this.onRemove}>حذف گروه</button>
          <button className="btn btn-outline-app" onClick={this.onCancel}>لغو</button>
        </div>
      </div>
    );
  }
}
